import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import React, { FC, useState } from "react";
import { ChevronDown as ExpandMoreIcon } from "mdi-material-ui";
import { useAppSelector } from "store";

interface Props {
  selecionado: number;
  onClick: (anoLetivo: number) => void;
  render: "accordion" | "autocomplete";
}

export const FilterAnoLetivo: FC<Props> = ({
  selecionado,
  onClick,
  render,
}) => {
  const [panel, setPanel] = useState(false);

  const {
    escola: { anoSite },
  } = useAppSelector((state) => state);

  const handleClick = (anoLetivo: number) => {
    onClick(anoLetivo);
    if (render == "accordion") setPanel(false);
  };

  const anoBase = parseInt(anoSite, 10);

  const anosLetivos = [
    anoBase - 2,
    anoBase - 1,
    anoBase,
    anoBase + 1,
    anoBase + 2,
  ];

  if (render == "accordion") {
    return (
      <Accordion
        elevation={0}
        expanded={panel}
        onChange={() => setPanel(!panel)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container>
            <Grid item xs={12} component={Typography} variant="subtitle2">
              Ano letivo
            </Grid>
            <Grid item xs={12} component={Typography} variant="caption">
              {selecionado}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <List dense>
            {anosLetivos.map((ano) => (
              <ListItemButton
                key={`filter-ano-${ano}`}
                onClick={() => handleClick(ano)}
              >
                <ListItemIcon>
                  <Radio checked={ano == selecionado} />
                </ListItemIcon>
                <ListItemText
                  primary={ano}
                  primaryTypographyProps={{
                    noWrap: true,
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <TextField
      select
      label="Matéria"
      value={selecionado}
      onChange={({ target: { value } }) => onClick(parseInt(value, 10))}
    >
      {anosLetivos.map((ano) => (
        <MenuItem key={`filter-ano-${ano}`} value={ano.toString()}>
          {ano}
        </MenuItem>
      ))}
    </TextField>
  );
};
